import { Input, InputNumber } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { FormItem } from '../../../components/form-item'

export function CampaignBasicsSection() {
    const { t } = useTranslation()

    return (
        <>
            <FormItem
                label={t('Title')}
                name="title"
            >
                <Input placeholder={t('Enter title')} />
            </FormItem>

            <FormItem
                name="monthlyConversationLimit"
                label={t('Monthly conversation limit')}
            >
                <InputNumber
                    min={1}
                    className="w-full"
                    placeholder={t('No limit')}
                />
            </FormItem>
        </>
    )
}
